import { useAirModal } from '@air/provider-modal';

import { CreditsDepletedModal } from '~/components/Modals/CreditsDepletedModal';
import { useCreditStats } from '~/swr-hooks/workspaces/useCreditStats';

export const useCanConsumeMoreCredits = () => {
  const { data: creditStats } = useCreditStats();
  const [showCreditsDepletedModal] = useAirModal(CreditsDepletedModal);

  // Should be `false` only if credit stats are available and explicitly set to `false`
  const canConsumeMoreCredits = creditStats?.canConsumeMoreCredits !== false;

  return {
    canConsumeMoreCredits,
    showCreditsDepletedModal,
  };
};
